import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLockClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 18 18" {...props}>
    {/* Lock shackle (closed) */}
    <path d="M5 8V5C5 2.79 6.79 1 9 1s4 1.79 4 4v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    {/* Lock body (outline) */}
    <rect x="3" y="8" width="12" height="8" rx="2" stroke="currentColor" strokeWidth="1.5" />
    {/* Keyhole dot */}
    <circle cx="9" cy="12" r="1.5" fill="currentColor" />
  </svg>
);
export default SvgLockClosed;
